import { motion } from "framer-motion";

const BROKER_PORTRAIT =
  "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function About() {
  return (
    <section id="coverage" className="bg-cream" data-testid="about-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-40 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[3/4] max-w-[480px] overflow-hidden"
          >
            <div
              className="absolute inset-0 bg-cover bg-top"
              style={{ backgroundImage: `url(${BROKER_PORTRAIT})` }}
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-ink/10" />
            <div className="absolute bottom-6 left-6 text-cream text-[10px] tracking-[0.3em]">
              THE FAMILIES WE PROTECT
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7">
          <div className="text-ink/40 text-[11px] tracking-[0.3em] mb-8 flex items-center gap-4">
            <span className="w-8 h-[1px] bg-ink/30" />
            CHAPTER 09 · THE HAND ON THE PAGE
          </div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="font-serif text-ink text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight mb-10"
          >
            Independent by design. <span className="italic text-terracotta">Ferrari optional.</span>
          </motion.h2>
          <p className="text-ink/70 text-base md:text-lg leading-relaxed max-w-xl font-light mb-8">
            Experior Financial Group is an independent brokerage — never captive
            to a single carrier. I shop the top-rated companies in America
            and put my name behind the policy that fits your family, your
            income, and the life you're actually building.
          </p>
          <p className="text-ink/70 text-base md:text-lg leading-relaxed max-w-xl font-light">
            No jargon. No slide decks. Just a phone call, a straight number,
            and paperwork that gets signed the same week. That's it.
          </p>

          <div className="grid grid-cols-3 gap-8 mt-16 max-w-xl">
            {[
              ["4,200+", "FAMILIES INSURED"],
              ["42", "STATES LICENSED"],
              ["A+", "CARRIER RATING FLOOR"],
            ].map(([n, l]) => (
              <div key={l} className="border-t border-ink/20 pt-4">
                <div className="font-serif text-4xl md:text-5xl text-ink tabular-nums font-light">{n}</div>
                <div className="text-[10px] tracking-[0.25em] text-ink/50 mt-3">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
